if (!customElements.get('product-info')) {

  var v_id = null; 
  
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();
        
        if(selectedOptionValues[0] != v_id ){
          var newOptions = this.linkedOptions(selectedOptionValues[0]);
          if(newOptions.length == 3){
            selectedOptionValues = newOptions;
          } 
          }
        

        console.warn(v_id + " ---> " + selectedOptionValues[0]);
        console.warn(" ---> " + selectedOptionValues[1]);
        console.warn(" ---> " + selectedOptionValues[2]);
        
        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
        v_id = selectedOptionValues[0];
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);
          //variant.id = 49364192395603;
          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      linkedOptions(material){
      var selectedOptionValues = new Array();

        // ------- Dein Watercolor-Design ------------
          if(material == "402663938915"){
            selectedOptionValues.push("402663938915"); // Leinwand
            selectedOptionValues.push("417416413523"); // 20x20
            selectedOptionValues.push("417416839507"); // 1 Liebling
          } else if (material == "417416282451") {
            selectedOptionValues.push("417416282451"); // Poster
            selectedOptionValues.push("417416413523"); // 30x20
            selectedOptionValues.push("417416839507"); // 1 Liebling
          } else if (material == "417416380755") {
             selectedOptionValues.push("417416380755");
            selectedOptionValues.push("417416544595");
            selectedOptionValues.push("417416839507");
          } else if (material == "4010804183379") {
            selectedOptionValues.push("4010804183379");
            selectedOptionValues.push("4010804707667");
            selectedOptionValues.push("417416839507");
          }

        // ------- Dein Aquarell-Design ------------
           if(material == "417441349971"){
            selectedOptionValues.push("417441349971");
            selectedOptionValues.push("417441481043");
            selectedOptionValues.push("417441907027");
          } else if (material == "417441448275") {
            selectedOptionValues.push("417441448275");
            selectedOptionValues.push("417441612115");
            selectedOptionValues.push("417441907027");
          } else if (material == "4026445758803") {
             selectedOptionValues.push("4026445758803");
            selectedOptionValues.push("417441481043");
            selectedOptionValues.push("417441907027");
          } else if (material == "4010858971475") {
            selectedOptionValues.push("4010858971475");
            selectedOptionValues.push("4010859528531");
            selectedOptionValues.push("417441907027");
          }

        // ------- Dein Schattenportrait-Design ------------
           if(material == "417412186451"){
            selectedOptionValues.push("417412186451");
            selectedOptionValues.push("417412317523");
            selectedOptionValues.push("417412743507");
          } else if (material == "417412284755") {
            selectedOptionValues.push("417412284755");
            selectedOptionValues.push("417412448595");
            selectedOptionValues.push("417412743507");
          } else if (material == "4026613367123") {
             selectedOptionValues.push("4026613367123");
            selectedOptionValues.push("417412317523");
            selectedOptionValues.push("417412743507");
          } else if (material == "4010848289107") {
            selectedOptionValues.push("4010848289107");
            selectedOptionValues.push("4010848747859");
            selectedOptionValues.push("417412743507");
          }

          // ------- Dein Klassiker-Design ------------
           if(material == "417402356051"){
            selectedOptionValues.push("417402356051");
            selectedOptionValues.push("417402487123");
            selectedOptionValues.push("417402913107");
          } else if (material == "417402454355") {
            selectedOptionValues.push("417402454355");
            selectedOptionValues.push("417402618195");
            selectedOptionValues.push("417402913107");
          } else if (material == "4026548126035") {
             selectedOptionValues.push("4026548126035");
            selectedOptionValues.push("417402487123");
            selectedOptionValues.push("417402913107");
          } else if (material == "4010829447507") {
            selectedOptionValues.push("4010829447507");
            selectedOptionValues.push("4010829971795");
            selectedOptionValues.push("417402913107");
          }

          // ------- Dein Love-Design ------------
           if(material == "417404846419"){
            selectedOptionValues.push("417404846419");
            selectedOptionValues.push("417404977491");
            selectedOptionValues.push("417405403475");
          } else if (material == "417404944723") {
            selectedOptionValues.push("417404944723");
            selectedOptionValues.push("417405108563");
            selectedOptionValues.push("417405403475");
          } else if (material == "4026562085203") {
             selectedOptionValues.push("4026562085203");
            selectedOptionValues.push("417404977491");
            selectedOptionValues.push("417405403475");
          } else if (material == "4010837868883") {
            selectedOptionValues.push("4010837868883");
            selectedOptionValues.push("4010838393171");
            selectedOptionValues.push("417405403475");
          }

          // ------- Dein Memory-Design ------------
           if(material == "417405862227"){
            selectedOptionValues.push("417405862227");
            selectedOptionValues.push("417405993299");
            selectedOptionValues.push("417406419283");
          } else if (material == "417405960531") {
            selectedOptionValues.push("417405960531");
            selectedOptionValues.push("417406124371");
            selectedOptionValues.push("417406419283");
          } else if (material == "4026580795731") {
             selectedOptionValues.push("4026580795731");
            selectedOptionValues.push("417405993299");
            selectedOptionValues.push("417406419283");
          } else if (material == "4010841801043") {
            selectedOptionValues.push("4010841801043");
            selectedOptionValues.push("4010842325331");
            selectedOptionValues.push("417406419283");
          }

        // ------- Dein Black&Gold/Silver/Roségold-Design ------------
           if(material == "417399963987"){
            selectedOptionValues.push("417399963987");
            selectedOptionValues.push("417400095059");
            selectedOptionValues.push("417400521043");
          } else if (material == "417400062291") {
            selectedOptionValues.push("417400062291");
            selectedOptionValues.push("417400226131");
            selectedOptionValues.push("417400521043");
          } else if (material == "4026490159443") {
             selectedOptionValues.push("4026490159443");
            selectedOptionValues.push("417400095059");
            selectedOptionValues.push("417400521043");
          } else if (material == "4010866606419") {
            selectedOptionValues.push("4010866606419");
            selectedOptionValues.push("4010867196243");
            selectedOptionValues.push("417400521043");
          }

        // ------- Dein Naturliebe-Design ------------
           if(material == "417409073491"){
            selectedOptionValues.push("417409073491");
            selectedOptionValues.push("417409204563");
            selectedOptionValues.push("417409630547");
          } else if (material == "417409171795") {
            selectedOptionValues.push("417409171795");
            selectedOptionValues.push("417409335635");
            selectedOptionValues.push("417409630547");
          } else if (material == "4026605732179") {
             selectedOptionValues.push("4026605732179");
            selectedOptionValues.push("417409204563");
            selectedOptionValues.push("417409630547");
          } else if (material == "4010845602131") {
            selectedOptionValues.push("4010845602131");
            selectedOptionValues.push("4010846126419");
            selectedOptionValues.push("417409630547");
          }

        // ------- Dein Spiegelportrait-Design ------------
           if(material == "417413529939"){
            selectedOptionValues.push("417413529939");
            selectedOptionValues.push("417413661011");
            selectedOptionValues.push("417414086995");
          } else if (material == "417413628243") {
            selectedOptionValues.push("417413628243");
            selectedOptionValues.push("417413792083");
            selectedOptionValues.push("417414086995");
          } else if (material == "4026621493587") {
             selectedOptionValues.push("4026621493587");
            selectedOptionValues.push("417413661011");
            selectedOptionValues.push("417414086995");
          } else if (material == "4010853466451") {
            selectedOptionValues.push("4010853466451");
            selectedOptionValues.push("4010853990739");
            selectedOptionValues.push("417414086995");
          }

        // ------- Dein Dreamcatcher-Design ------------
           if(material == "3925185495379"){
            selectedOptionValues.push("3925185495379");
            selectedOptionValues.push("3925185691987");
            selectedOptionValues.push("3925186019667");
          } else if (material == "3925185528147") {
            selectedOptionValues.push("3925185528147");
            selectedOptionValues.push("3925185724755");
            selectedOptionValues.push("3925186019667");
          } else if (material == "4026505822547") {
             selectedOptionValues.push("4026505822547");
            selectedOptionValues.push("3925185691987");
            selectedOptionValues.push("3925186019667");
          } else if (material == "4010808115539") {
            selectedOptionValues.push("4010808115539");
            selectedOptionValues.push("4010808607059");
            selectedOptionValues.push("3925186019667");
          }

        // ------- Dein Splash-Design ------------
           if(material == "417397539155"){
            selectedOptionValues.push("417397539155");
            selectedOptionValues.push("417397670227");
            selectedOptionValues.push("417398096211");
          } else if (material == "417397637459") {
            selectedOptionValues.push("417397637459");
            selectedOptionValues.push("417397801299");
            selectedOptionValues.push("417398096211");
          } else if (material == "4026631749971") {
             selectedOptionValues.push("4026631749971");
            selectedOptionValues.push("417397670227");
            selectedOptionValues.push("417398096211");
          } else if (material == "4010800709971") {
            selectedOptionValues.push("4010800709971");
            selectedOptionValues.push("4010801234259");
            selectedOptionValues.push("417398096211");
          }

         // ------- Dein Graffiti-Design ------------
           if(material == "417401340243"){
            selectedOptionValues.push("417401340243");
            selectedOptionValues.push("417401471315");
            selectedOptionValues.push("417401897299");
          } else if (material == "417401438547") {
            selectedOptionValues.push("417401438547");
            selectedOptionValues.push("417401602387");
            selectedOptionValues.push("417401897299");
          } else if (material == "4026530234707") {
             selectedOptionValues.push("4026530234707");
            selectedOptionValues.push("417401471315");
            selectedOptionValues.push("417401897299");
          } else if (material == "4010813555027") {
            selectedOptionValues.push("4010813555027");
            selectedOptionValues.push("4010814046547");
            selectedOptionValues.push("417401897299");
          }

        // ------- Dein Arty-Design ------------
           if(material == "417439646035"){
            selectedOptionValues.push("417439646035");
            selectedOptionValues.push("417439777107");
            selectedOptionValues.push("417440203091");
          } else if (material == "417439744339") {
            selectedOptionValues.push("417439744339");
            selectedOptionValues.push("417439908179");
            selectedOptionValues.push("417440203091");
          } else if (material == "4026474234195") {
             selectedOptionValues.push("4026474234195");
            selectedOptionValues.push("417439777107");
            selectedOptionValues.push("417440203091");
          } else if (material == "4010862707027") {
            selectedOptionValues.push("4010862707027");
            selectedOptionValues.push("4010863231315");
            selectedOptionValues.push("417440203091");
          }

        // ------- Deine Pfötchen-Zeichnung ------------
           if(material == "417410253139"){
            selectedOptionValues.push("417410253139");
            selectedOptionValues.push("417410384211");
            selectedOptionValues.push("417410744659");
          } else if (material == "417410351443") {
            selectedOptionValues.push("417410351443");
            selectedOptionValues.push("417410515283");
            selectedOptionValues.push("417410744659");
          } else if (material == "4026722648403") {
             selectedOptionValues.push("4026722648403");
            selectedOptionValues.push("417410384211");
            selectedOptionValues.push("417410744659");
          } else if (material == "4010794352979") {
            selectedOptionValues.push("4010794352979");
            selectedOptionValues.push("4010794778963");
            selectedOptionValues.push("417410744659");
          }

        // ------- Deine LineArt-Zeichnung (farbig) ------------
           if(material == "692389806419"){
            selectedOptionValues.push("692389806419");
            selectedOptionValues.push("692389970259");
            selectedOptionValues.push("692390297939");
          } else if (material == "692389839187") {
            selectedOptionValues.push("692389839187");
            selectedOptionValues.push("692390003027");
            selectedOptionValues.push("692390297939");
          } else if (material == "4026650394963") {
             selectedOptionValues.push("4026650394963");
            selectedOptionValues.push("692389970259");
            selectedOptionValues.push("692390297939");
          } else if (material == "4010790682963") {
            selectedOptionValues.push("4010790682963");
            selectedOptionValues.push("4010791305555");
            selectedOptionValues.push("692390297939");
          }

        // ------- Deine Pfötchen-Zeichnung ------------
          if(material == "968737587539"){
            selectedOptionValues.push("968737587539");
            selectedOptionValues.push("968737653075");
            selectedOptionValues.push("968737947987");
          } else if (material == "968737620307") {
            selectedOptionValues.push("968737620307");
            selectedOptionValues.push("968737685843");
            selectedOptionValues.push("968737947987");
          } else if (material == "4026746765651") {
             selectedOptionValues.push("4026746765651");
            selectedOptionValues.push("968737653075");
            selectedOptionValues.push("968737947987");
          } else if (material == "4010797138259") {
            selectedOptionValues.push("4010797138259");
            selectedOptionValues.push("4010797695315");
            selectedOptionValues.push("968737947987");
          }
        return selectedOptionValues;
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
